/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionRecordListInner } from './get-suspicious-transactions200-response-transaction-detail-list-inner-one-of1-card-transaction-transaction-record-list-inner';

/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'failureReason': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'transactionType': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'transactionStatus': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionRecordListInner>}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'transactionRecordList': Array<GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionRecordListInner>;
}

export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionTypeEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionTypeEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionTypeEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionStatusEnum = {
    fail: 'FAIL'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionStatusEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionStatusEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionStatusEnum];


